/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgUnitReserveAvailabilityRetrievePathOrgUnitId,
	OrgUnitReserveAvailabilityRetrieveQueryDate,
	OrgUnitReserveAvailabilityRetrieveQueryDurationMinutes,
	OrgUnitReserveAvailabilityRetrieveQueryGuestsCount,
	OrgUnitReserveAvailabilityRetrieveQueryReserveId,
	OrgUnitReserveAvailabilityRetrieveStatus200,
} from "../types/OrgUnitReserveAvailabilityRetrieve.ts";
import type { QueryKey, QueryClient, UseQueryOptions, UseQueryReturnType } from "@tanstack/vue-query";
import type { MaybeRefOrGetter } from "vue";
import { orgUnitReserveAvailabilityRetrieve } from "../requests/orgUnitReserveAvailabilityRetrieve.ts";
import { queryOptions, useQuery } from "@tanstack/vue-query";
import { toValue } from "vue";

export const orgUnitReserveAvailabilityRetrieveQueryKey = (
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveAvailabilityRetrievePathOrgUnitId>,
	params?: MaybeRefOrGetter<{
		date: OrgUnitReserveAvailabilityRetrieveQueryDate;
		duration_minutes?: OrgUnitReserveAvailabilityRetrieveQueryDurationMinutes;
		guests_count: OrgUnitReserveAvailabilityRetrieveQueryGuestsCount;
		reserve_id?: OrgUnitReserveAvailabilityRetrieveQueryReserveId;
	}>,
) => [{ url: "/api/org_unit/:org_unit_id/reserve/availability/", params: { org_unit_id: org_unit_id } }, ...(params ? [params] : [])] as const;

export type OrgUnitReserveAvailabilityRetrieveQueryKey = ReturnType<typeof orgUnitReserveAvailabilityRetrieveQueryKey>;

export function orgUnitReserveAvailabilityRetrieveQueryOptions(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveAvailabilityRetrievePathOrgUnitId>,
	params?: MaybeRefOrGetter<{
		date: OrgUnitReserveAvailabilityRetrieveQueryDate;
		duration_minutes?: OrgUnitReserveAvailabilityRetrieveQueryDurationMinutes;
		guests_count: OrgUnitReserveAvailabilityRetrieveQueryGuestsCount;
		reserve_id?: OrgUnitReserveAvailabilityRetrieveQueryReserveId;
	}>,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const queryKey = orgUnitReserveAvailabilityRetrieveQueryKey(org_unit_id, params);
	return queryOptions<OrgUnitReserveAvailabilityRetrieveStatus200, ResponseErrorConfig<Error>, OrgUnitReserveAvailabilityRetrieveStatus200>({
		enabled: () => !!toValue(org_unit_id) && !!toValue(params),
		queryKey,
		queryFn: async ({ signal }) => {
			return orgUnitReserveAvailabilityRetrieve(toValue(org_unit_id!), toValue(params!), { ...config, signal: config.signal ?? signal });
		},
	});
}

/**
 * @summary доступное время бронирования по залам и столам на дату
 * {@link /api/org_unit/:org_unit_id/reserve/availability/}
 */
export function useOrgUnitReserveAvailabilityRetrieve<
	TData = OrgUnitReserveAvailabilityRetrieveStatus200,
	TQueryData = OrgUnitReserveAvailabilityRetrieveStatus200,
	TQueryKey extends QueryKey = OrgUnitReserveAvailabilityRetrieveQueryKey,
>(
	org_unit_id?: MaybeRefOrGetter<OrgUnitReserveAvailabilityRetrievePathOrgUnitId>,
	params?: MaybeRefOrGetter<{
		date: OrgUnitReserveAvailabilityRetrieveQueryDate;
		duration_minutes?: OrgUnitReserveAvailabilityRetrieveQueryDurationMinutes;
		guests_count: OrgUnitReserveAvailabilityRetrieveQueryGuestsCount;
		reserve_id?: OrgUnitReserveAvailabilityRetrieveQueryReserveId;
	}>,
	options: {
		query?: Partial<UseQueryOptions<OrgUnitReserveAvailabilityRetrieveStatus200, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
			client?: QueryClient;
		};
		client?: Partial<RequestConfig> & { client?: Client };
	} = {},
) {
	const { query: queryConfig = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...resolvedOptions } = queryConfig;
	const queryKey =
		(resolvedOptions && "queryKey" in resolvedOptions ? toValue(resolvedOptions.queryKey) : undefined) ??
		orgUnitReserveAvailabilityRetrieveQueryKey(org_unit_id, params);

	const query = useQuery(
		{
			...orgUnitReserveAvailabilityRetrieveQueryOptions(org_unit_id, params, config),
			...resolvedOptions,
			queryKey,
		} as unknown as UseQueryOptions<
			OrgUnitReserveAvailabilityRetrieveStatus200,
			ResponseErrorConfig<Error>,
			TData,
			OrgUnitReserveAvailabilityRetrieveStatus200,
			TQueryKey
		>,
		toValue(queryClient),
	) as UseQueryReturnType<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
